<template>
  <div class="is-marginless is-paddingless section section-details" v-if="contrat">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailContrat.title', { code: contrat.code })}}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">

            <dropdownButton
              type="is-addOrEdit"
              class="mgr-2"
              :permission="permsContrat.maj"
              :actions="actionSecondary"
              @click="() => {
                $router.push({ name: 'm.baux.contrat-edit',
                  params: { id: contrat.id } });
              }">
                {{ $t('detailContrat.actions.edit') }}
            </dropdownButton>

            <button class="button is-addOrEdit" v-if="contrat.etat === contratEtatEnregistre"
            @click="checkPermissions(permsContrat.maj) ?
                      popUpCloture = true : showPopUp()"
                    :class="{'button-access-no-permission': !checkPermissions(permsContrat.maj)}">
              {{ $t('detailContrat.actions.cloture') }}
            </button>

            <button class="button is-addOrEdit" v-if="contrat.etat === contratEtatClos"
                    @click="checkPermissions(permsContrat.maj) ?
                      popUpPreventionReactivation = true : showPopUp()"
                    :class="{'button-access-no-permission': !checkPermissions(permsContrat.maj)}">
              {{ $t('detailContrat.actions.reactiver') }}
            </button>

            <button class="button is-addOrEdit" v-if="contrat.etat === contratEtatBrouillon"
                    @click="checkPermissions(permsContrat.maj) ?
                      popUpPreventionEnregistrement = true : showPopUp()"
                    :class="{'button-access-no-permission': !checkPermissions(permsContrat.maj)}">
              {{ $t('detailContrat.actions.enregistrer') }}
            </button>

            <button class="button is-addOrEdit"
                    @click="checkPermissions(permsFactureAchat.maj) ?
                      selectionIntervenantPourFactureAchat() : showPopUp()"
                    :class="{'button-access-no-permission':
                    !checkPermissions(permsFactureAchat.maj)}">
              {{ $t('detailContrat.actions.creationFactureBailleur') }}
            </button>
            <button class="button">
              <b-dropdown position="is-bottom-right">
                <div slot="trigger">
                  <b-icon icon="file-download" type="is-default"/>
                  <b-icon icon="chevron-down" class="has-text-secondary-icon"/>
                </div>
                <b-dropdown-item
                  @click="checkPermissions(permsContrat.editer) ? edition({
                    format: constantes.TYPE_PDF,
                    typeDonnee: constantes.TYPE_EDITION_CONTRAT_CRIP
                  }) : showPopUp()">
                  {{ $t('general.popUpEdition.type.pdf') }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="checkPermissions(permsContrat.editer) ? edition({
                    format: constantes.TYPE_DOCX,
                    typeDonnee: constantes.TYPE_EDITION_CONTRAT_CRIP
                  }) : showPopUp()">
                  {{ $t('general.popUpEdition.type.docx') }}
                </b-dropdown-item>
              </b-dropdown>
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="permsContrat.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <div class="tab">
        <ul>
          <li :class="{'is-active': activeTab === 'bail'}"
              @click="activeTab = 'bail'">
            {{ $t('detailContrat.tab.bail') }}
          </li>
          <li :class="{'is-active': activeTab === 'materielsAssocies'}"
              @click="activeTab = 'materielsAssocies'">
            {{ $t('detailContrat.tab.materielsAssocies') }}
          </li>
          <li :class="{'is-active': activeTab === 'produitsAssocies'}"
              @click="activeTab = 'produitsAssocies'"
              v-if="modulePresseActive">
            {{ $t('ajoutEditContrat.tab.produitsAssocies') }}
          </li>
          <li :class="{'is-active': activeTab === 'echeancier'}"
              @click="activeTab = 'echeancier'">
              <b-tooltip v-if="isBlocagePaiement"
              :label="$t('detailContrat.blocagePaiement')"
              position="is-right"
              type="is-danger"
            >
            <div class="mgv-auto mgr-5px round-circle-danger"></div>
            </b-tooltip>
            <span>{{ $t('detailContrat.tab.echeancier') }}</span>
          </li>
          <li :class="{'is-active': activeTab === 'avenant'}"
              @click="activeTab = 'avenant'">
            {{ $t('detailContrat.tab.avenant') }}
          </li>
          <li
              v-if="modulePresseActive"
              :class="{'is-active': activeTab === 'commissionsFournisseur'}"
              @click="activeTab = 'commissionsFournisseur'">
            {{ $t('detailContrat.tab.commissions') }}
          </li>
          <li :class="{'is-active': activeTab === 'reglesAchat'}"
              @click="activeTab = 'reglesAchat'"
              v-if="modulePresseActive">
            {{ $t('catalogue.newProduct.tab.regleAchat') }}
          </li>
        </ul>
      </div>
    </div>
    <div>
      <component :is="activeTab"
                 :contrat="contrat"
                 :echeancier="echeancier"
                 :detail="true"
                 :produit="contrat"
                 :permissions="permsContrat"
                 :isViewAjout="false">
      </component>
    </div>
    <b-modal v-model="popUpCloture"
             has-modal-card
             class="modal">
      <pop-up-cloture
        :messHeader="$t('detailContrat.cloture.clotureTitle')"
        @close="popUpCloture = false"
        @reload="loadContratInformation"
        :contrat="contrat"
      />
    </b-modal>
    <b-modal v-model="popUpPreventionReactivation"
             has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('detailContrat.reactivation.reactivationTitle')"
        messFooter=""
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpPreventionReactivation = false"
        @yes="reactivationContrat()"
      />
    </b-modal>
    <b-modal v-model="popUpPreventionEnregistrement"
             has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('detailContrat.enregistrement.enregistrementTitle')"
        :msg-avertissements="getMsgAvertissement"
        messFooter=""
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpPreventionEnregistrement = false"
        @yes="enregistrementContrat()"
      />
    </b-modal>
    <b-modal v-model="popupSelectionIntervenant"
             has-modal-card
             class="modal">
      <selection-facturation-intervenant :intervenants="contrat.intervenants"
        @intervenantSelected="goToCreationFactureAchat">
      </selection-facturation-intervenant>
    </b-modal>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="this.$t('detailContrat.popUpSuppression.title')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteContrat"/>
    </b-modal>
    <b-modal v-model="popUpIndexation" has-modal-card class="modal">
      <pop-up-indexation
        @close="popUpIndexation = false"
        @reload="loadContratInformation"
        :contrat="contrat"/>
    </b-modal>
    <b-modal v-model="popUpReconductionContrat" has-modal-card class="modal">
      <reconduction-contrat :contratsAReconduire="contratAReconduire"
                            @closeAndRefresh="closeAndRefresh"/>
    </b-modal>
    <b-modal v-model="popupEtatRenouvellement" has-modal-card class="modal">
      <popUpRenouvellement :contrats="[contrat]"
                :etatRenouvellement="constantes.ETAT_NONRENOUVELEE"
                @reload="loadContratInformation"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import bail from '@/components/baux/contrat/componentDetail/bail';
import dropdownButton from '@/components/general/button/dropdownButton';
import materielsAssocies from '@/components/baux/contrat/materielsAssocies';
import produitsAssocies from '@/components/baux/contrat/produitsAssocies';
import {
  get, reactiver, brouillon2Contrat,
  deleteContrat,
} from '@/api/baux/contrat';
import edition from '@/api/edition/index';
import transformContrat from '@/services/baux/contrat/transformContrat';
import messageErreur from '@/services/general/messageErreur';
import { CONTRAT, FACTURE_ACHAT } from '@/configuration/baux/permissionsBauxConf';
import breadcrumb from '@/components/general/breadcrumb';
import {
  CONTRAT_ETAT_CLOS,
  CONTRAT_ETAT_ENREGISTRE,
  CONTRAT_ETAT_BROUILLON,
  TYPE_EDITION_CONTRAT_CRIP,
} from '@/configuration/baux/contrat/contratConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import popUpCloture from '@/components/baux/contrat/componentDetail/popUpCloctureBail';
import popUpIndexation from '@/components/baux/contrat/componentDetail/popUpIndexationBail';
import echeancier from '@/components/baux/contrat/componentDetail/echeancier';
import { getEcheancierContrat } from '@/api/commandeAchat';
import genererRenouvellementContrat from '@/services/baux/contrat/renouvellement/genererRenouvellementContrat';
import { SET_CONTRAT } from '@/store/modules/baux/contrat-mutation-type';
import messageSucces from '@/services/general/messageSucces';
import avenant from '@/components/baux/contrat/componentDetail/avenant';
import commissionsFournisseur from '@/components/factures/detail/commissionsFournisseur';
import reglesAchat from '@/components/catalogue/produitGeneralPresse/edition/reglesAchat';
import selectionFacturationIntervenant from '@/components/baux/contrat/p_selectionFacturationIntervenant';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { TYPE_PDF, TYPE_DOCX } from '@/configuration/edition/editionConf';
import reconductionContrat from '@/components/baux/contrat/p_reconductionContrat';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import popUpRenouvellement from '@/components/baux/contrat/componentDetail/popUpRenouvellement';
import { ETAT_NONRENOUVELEE } from '@/configuration/devisConf';

const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');
const Contrat = createNamespacedHelpers('contrat');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      contrat: null,
      activeTab: 'bail',
      permsContrat: CONTRAT,
      permsFactureAchat: FACTURE_ACHAT,
      contratEtatEnregistre: CONTRAT_ETAT_ENREGISTRE,
      contratEtatClos: CONTRAT_ETAT_CLOS,
      contratEtatBrouillon: CONTRAT_ETAT_BROUILLON,
      popUpIndexation: false,
      popUpCloture: false,
      popUpPreventionReactivation: false,
      popUpPreventionEnregistrement: false,
      echeancier: {},
      popupSelectionIntervenant: false,
      popupEtatRenouvellement: false,
      constantes: {
        TYPE_PDF,
        TYPE_DOCX,
        TYPE_EDITION_CONTRAT_CRIP,
        ETAT_NONRENOUVELEE,
      },
      popUpSuppression: false,
      popUpReconductionContrat: false,
    };
  },
  components: {
    bail,
    materielsAssocies,
    breadcrumb,
    dropdownButton,
    popUpPrevention,
    popUpCloture,
    popUpIndexation,
    echeancier,
    avenant,
    commissionsFournisseur,
    reglesAchat,
    selectionFacturationIntervenant,
    reconductionContrat,
    produitsAssocies,
    pieceJointeButton,
    popUpRenouvellement,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    breadcrumb() {
      return [
        { title: this.$t('detailContrat.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('detailContrat.breadcrumb.liste'), route: { name: 'l.baux.contrat' }, isActive: false },
        { title: this.$t('detailContrat.breadcrumb.detail'), route: '', isActive: true },
      ];
    },
    contratAReconduire() {
      return [this.contrat];
    },
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    getMsgAvertissement() {
      const messages = [];
      if (this.contrat.echeancier.length === 0) {
        messages.push({ message: this.$i18n.t('detailContrat.info.avertissement.noEcheancier') });
      }
      if (this.contrat.contratsMateriels.length === 0) {
        messages.push({ message: this.$i18n.t('detailContrat.info.avertissement.noMateriel') });
      }
      return messages;
    },
    isBlocagePaiement() {
      return this.contrat.blocageReglement || this.contrat.intervenants.filter(el => {
        return el.tiers.blocageReglement;
      }).length > 0;
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('detailContrat.actions.renouvellement'),
          action: () => { this.renouveler(); },
          permissionAction: CONTRAT.maj,
        },
        {
          label: this.$t('detailContrat.actions.nonRenouvellement'),
          action: () => { this.popupEtatRenouvellement = true; },
          permissionAction: CONTRAT.maj,
        },
      ];

      if (this.contrat.etat === this.contratEtatBrouillon) {
        actions.push(
          {
            label: this.$t('general.button.delete'),
            action: () => { this.popUpSuppression = true; },
            permissionAction: CONTRAT.supprimer,
          },
        );
      }

      if (this.contrat.reconductible && this.contrat.etat !== this.contratEtatClos) {
        actions.push(
          {
            label: this.$t('detailContrat.actions.reconduire'),
            action: () => { this.popUpReconductionContrat = true; },
          },
        );
      }

      if (this.contrat.estIndexe && this.contrat.typeIndexation !== null
        && this.contrat.etat !== this.contratEtatClos) {
        actions.push(
          {
            label: this.$t('detailContrat.indexation.inderBail'),
            action: () => { this.popUpIndexation = true; },
            permissionAction: CONTRAT.maj,
          },
        );
      }

      return actions;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Contrat.mapMutations({
      setContrat: SET_CONTRAT,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async goToCreationFactureAchat(tiersId) {
      await this.$router.push({ name: 'm.baux.facture_achat-creation-via-bail', params: { idBail: this.contrat.id, tiersId: tiersId } });
    },
    selectionIntervenantPourFactureAchat() {
      if (this.contrat.intervenants.length > 1) this.popupSelectionIntervenant = true;
      else this.goToCreationFactureAchat(this.contrat.intervenants[0].tiersId);
    },
    async renouveler() {
      const newContrat = genererRenouvellementContrat(this.contrat, this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.nbAnneeRenouvellementContrat.key,
      ));
      this.setContrat(newContrat);
      await this.$router.push({ name: 'm.baux.contrat-ajout' });
    },
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    async closeAndRefresh() {
      this.popUpReconductionContrat = false;
      await this.loadContratInformation();
    },
    async reactivationContrat() {
      this.popUpPreventionReactivation = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await reactiver(this.contrat.id);
        messageSucces(this.$i18n.t('detailContrat.reactivation.successReactivation'));
        this.$router.go(0);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async enregistrementContrat() {
      this.popUpPreventionEnregistrement = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await brouillon2Contrat(this.contrat.id);
        messageSucces(this.$i18n.t('detailContrat.enregistrement.successEnregistrement'));
        this.$router.go(0);
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [this.contrat.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async deleteContrat() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteContrat([this.$route.params.id]);
        messageSucces(this.$t('detailContrat.popUpSuppression.messagesSuccess'));
        loadingComponent.close();
        this.$router.push({ name: 'l.baux.contrat' });
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async loadContratInformation() {
      let contrat = (await get(this.$route.params.id)).data.result;
      await this.setAttachmentElementId({ id: contrat.id });
      contrat = transformContrat(contrat);
      const echeancier = (await getEcheancierContrat(this.$route.params.id)).data.result;
      echeancier.forEach((echeance) => {
        echeance.debutPeriode = moment(echeance.debutPeriode).toDate();
        echeance.finPeriode = moment(echeance.finPeriode).toDate();
        echeance.dateEcheance = moment(echeance.dateEcheance).toDate();
        echeance.selected = false;
      });
      contrat.echeancier = echeancier;
      this.contrat = contrat;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Contrat' });
      await this.loadContratInformation();
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.nbAnneeRenouvellementContrat.key]);
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.contrat.code }));
      if (this.$route.name === 'c.baux.contrat-facture-in-echeancier') {
        this.activeTab = 'echeancier';
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
